import React from 'react';
import Video from '../Video';
import FadeIn from '../animations/FadeIn';
import getHelpFileURL from '../../utils/getHelpFileURL';

export default function VideoEmbed({
  title,
  file,
  poster,
  autoplay,
  loop,
  muted,
  playsinline,
  paddingTop = '0',
  paddingBottom = '0',
}) {
  return (
    file && (
      <div
        style={{
          paddingTop,
          paddingBottom,
        }}
      >
        {title && (
          <h2 className="text-[2.25rem] leading-[1.2] !mb-10 max-w-3xl text-center mx-auto">
            {title}
          </h2>
        )}
        <FadeIn>
          <div className="my-0 mx-auto max-w-5xl">
            <Video
              video={getHelpFileURL(file)}
              autoplay={autoplay}
              loop={loop}
              muted={muted}
              playsinline={playsinline}
              poster={poster}
            />
          </div>
        </FadeIn>
      </div>
    )
  );
}
